import {
    chakra, Flex
} from '@chakra-ui/react';

export const NeedHelpContainer = chakra(Flex, {
    label: 'NeedHelpButton',
    baseStyle: {
        alignItems: 'center',
        justifyContent: 'center',
        h: '40px',
        minW: '40px',
        border: '1px solid',
        borderColor: 'var(--3p-colors-primary-200)',
        borderRadius: '100px',
        backgroundColor: '#fff',
        cursor: 'pointer',
        _hover: { backgroundColor: 'var(--3p-colors-primary-50)' }
    }
});
